import PermissionTable from './PermissionTable';

export default PermissionTable;
